export var BID_TYPE;
(function (BID_TYPE) {
    BID_TYPE["MV"] = "mv";
    BID_TYPE["MC"] = "mc";
    BID_TYPE["MC_WITH_TAG"] = "mcWithTag";
})(BID_TYPE || (BID_TYPE = {}));
export const FREE_CARD_UNUSED_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647369978-video.mp4',
    configJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647369978-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647369978-mtap.json'
};
export const FREE_CARD_USED_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647445777-video.mp4',
    configJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647445777-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647445777-mtap.json'
};
export const ASSIST_MODAL_VAP = {
    mp4: 'https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1747821327814-video.mp4',
    configJson: 'https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1747821327814-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1747821327814-mtap.json'
};
export const CITY_SELECTOR_CITY_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647175704-video.mp4',
    configJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647175704-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647175704-mtap.json'
};
export const CITY_ITEM_HAND_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1770349057101-video.mp4',
    configJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1770349057101-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1770349057101-mtap.json'
};
export const BID_MAP = {
    COMPONENT_MV: 'b_daodian_lowcode_mqc3qxzy_mv',
    /** 主卡片曝光 */
    CITY_EXPLORE_MAIN_CARD_MV: 'b_daodian_lowcode_loagfl59_mv',
    CITY_SELECTOR_MODAL_MV: 'b_daodian_lowcode_extxxg37_mv',
    /** 城市选择 - 曝光 */
    CITY_SELECTOR_MV: 'b_daodian_lowcode_wcrf2ac8_mv',
    /** 城市选择 - 点击 */
    CITY_SELECT_MC: 'b_daodian_lowcode_20tyjppd_mc',
    /** 换一批 */
    REFRESH_CITIES_MC: 'b_daodian_lowcode_f4n9dugh_mc',
    /** 城市筛选 */
    CITY_SEARCH_MC: 'b_daodian_lowcode_2l0wyhmh_mc',
    /** 地标 - 点击 */
    LANDMARK_CLICK_MC: 'b_daodian_lowcode_4i3f8fha_mc',
    /** 邀请按钮 - 曝光 */
    INVITE_BUTTON_MV: 'b_daodian_lowcode_vn3edml7_mv',
    /** 邀请按钮 - 点击 */
    INVITE_BUTTON_MC: 'b_daodian_lowcode_8hk54w4v_mc',
    /** 奖励按钮&记录按钮 - 点击 */
    REWARD_BUTTON_MC: 'b_daodian_lowcode_9k2k0o4w_mc',
    /** 免单卡弹窗 - 曝光 */
    FREE_CARD_MODAL_MV: 'b_daodian_lowcode_h2zvtaug_mv',
    /** 助力弹窗 - 曝光 */
    ASSIST_MODAL_MV: 'b_daodian_lowcode_qtcl7roo_mv',
    /** 免单卡 - 去使用 */
    FREE_CARD_USE_MC: 'b_daodian_lowcode_8lgh3dqj_mc',
    /** 券弹窗 - 曝光 */
    COUPON_MODAL_MV: 'b_daodian_lowcode_zwbohvay_mv',
    /** 助力弹窗 - 曝光 */
    ASSIST_MODAL_JOIN_ACTIVITY_BUTTON_MC: 'b_daodian_lowcode_kloq1qz8_mc',
    /** 地标详情弹窗 - 曝光 */
    LANDMARK_DETAIL_MV: 'b_daodian_lowcode_mjcaarxr_mv'
};
